import { render, staticRenderFns } from "./nxImage.vue?vue&type=template&id=32756b9e&"
import script from "./nxImage.vue?vue&type=script&lang=js&"
export * from "./nxImage.vue?vue&type=script&lang=js&"
import style0 from "./nxImage.vue?vue&type=style&index=0&id=32756b9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports